<template>
  <div class="content">
    <div class="header" v-for="(item,index) in info" :key="index">
      <h6>{{item.title}}</h6>
      <p v-for="(i,j) in item.content" :key="j" v-html="i"></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: [
        {
          title: "探店吃喝玩乐注销须知",
          content: [
            "[重要] 在您注销您的探店吃喝玩乐帐号之前，请充分阅读、理解并同意下列事项：",
            "【特别提示】注销探店吃喝玩乐帐号为不可恢复的操作，除您已授权提供至第三方的信息以外，注销帐号后您将无法再使用本探店吃喝玩乐帐号或找回您浏览、关注、添加、绑定的任何内容或信息（即使您使用相同的手机号码再次注册并使用探店吃喝玩乐）。",
            "请确保您所申请注销的探店吃喝玩乐帐号应当是您本人依照《探店吃喝玩乐用户服务协议》的约定创建并由本公司提供给您本人的帐号。您应当依照本公司规定的程序或网站上的提示注销探店吃喝玩乐帐号。",
            "建议您在注销前自行备份探店吃喝玩乐帐号相关的所有信息，并请确认与本探店吃喝玩乐帐号相关的所有服务均已进行妥善处理。注销完成后，探店吃喝玩乐将删除您的个人信息或对其进行匿名化处理（法律法规另有规定的除外）。请您知悉并理解，根据相关法律法规规定相关日志记录探店吃喝玩乐将保留不少于6个月的时间。"
          ]
        },
        {
          title: "1.我们对您注销探店吃喝玩乐帐号的决定深表遗憾。如果您仍决定继续进行帐号注销，您的帐号需同时满足以下条件：",
          content: [
            "1.1 帐号处于安全状态： 最近1个月内无绑定手机/修改手机号等操作，帐号为正常使用中且30天内无任何帐号被限制的记录；",
            "1.2 帐号财产已结清，没有未完成或存在争议的服务： 帐号中没有资产、欠款、未结清的资金和虚拟权益；本帐号及通过本帐号接入的第三方中没有未完成或存在争议的服务。",
            "1.3 帐号权限解除： 帐号已解除与第三方产品、网站授权登录或绑定关系。",
            "1.4 帐号无任何未结争议纠纷，包括投诉举报或被投诉举报。"
          ]
        },
        {
          title: "2.探店吃喝玩乐帐号注销后，您将无法登录、使用本探店吃喝玩乐帐号，也将无法找回本探店吃喝玩乐帐号中及与帐号相关的任何内容或信息，包括但不限于：",
          content: [
            "2.1. 个人已提交的身份信息、帐号信息、探店吃喝玩乐好友关系等信息。",
            "2.2. 已发布的视频作品、随拍视频、动态、点赞、评论、转发、互动、粉丝、喜欢、收藏等内容数据。",
            "2.3. 帐号内钱包账户余额、奖励、收益、实名认证信息、交易记录、已绑定的银行卡等信息将被作废及删除。",
            "请确认帐号内无任何资产或虚拟权益，您曾获得的资产虚拟权益等财产性利益视为您同意放弃，将无法继续使用。您理解并同意，您将放弃探店吃喝玩乐的资产或权益，探店吃喝玩乐无法协助您恢复上述服务，也无法找回帐号相关的任何内容或信息。"
          ]
        },
        {
          title: "3.探店吃喝玩乐帐号注销将导致本公司终止为您提供服务，依《探店吃喝玩乐用户服务协议》和《隐私政策》等约定的双方权利义务终止，依法律法规另有规定、本页面其他条款另行约定不得终止的或依其性质不能终止的除外。",
          content: []
        },
        {
          title: "4.在您的探店吃喝玩乐帐号注销期间，如果您的帐号涉及争议纠纷，包括但不限于：投诉、举报、诉讼、仲裁、国家有权机关调查等，您理解并同意，探店吃喝玩乐有权自行决定是否终止本帐号的注销而无需另行得到您的同意。",
          content: []
        },
        {
          title: "5.注销本探店吃喝玩乐帐号并不代表本探店吃喝玩乐帐号注销前的账户行为和相关责任得到豁免或减轻。",
          content: []
        },
        {
          title: "政策更新日期：2021-11-04",
          content: []
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.content .mail{
  color:#4F83E2;
}
</style>

<style lang="scss" scoped>
.content {
  margin-bottom: 100px;
  .header {
    padding: 0px 29px;
    h6 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin: 35px 0 10px 0;
    }
    p {
      // text-align: justify;
      font-size: 26px;
      font-weight: 400;
      line-height:40px;
      color: rgba(85, 85, 85, 1);
    }
  }
}
</style>